// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CompanyList.css */

/* Estilo para o modal */
.custom-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    max-width: 400px;
    width: 100%;
    text-align: center;
  }
  
  /* Estilo para o overlay do modal */
  .custom-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }
  
  /* Estilo para a tabela de empresas */
  .table {
    margin-top: 20px;
  }
  
  /* Estilo para o botão Adicionar Empresas */
  .btn-primary {
    margin-top: 20px;
  }

/* Estilo para o botão Adicionar Empresas */
.btn.add-company {
    font-size: 14px; /* Tamanho da fonte reduzido */
    padding: 8px 16px; /* Preenchimento (espaçamento interno) */
    border-radius: 40px; /* Borda arredondada */
    position: absolute; /* Posicionamento absoluto */
    top: -10px; /* Ajuste a altura superior conforme necessário */
    left: 10; /* Alinhe com a esquerda */
    margin-top: 10px; /* Espaço entre os botões */
}

  
  /* Estilo para os botões de ação (Editar e Excluir) na tabela */
  .btn-warning,
  .btn-danger {
    margin-right: 5px;
  }

  .space{
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .text-modal{
    display: flex;
    justify-content: space-between;
    width: 100%;
    

  }`, "",{"version":3,"sources":["webpack://./src/pages/CompanyList.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB,wBAAwB;AACxB;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;EAEA,mCAAmC;EACnC;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA,qCAAqC;EACrC;IACE,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;IACE,gBAAgB;EAClB;;AAEF,2CAA2C;AAC3C;IACI,eAAe,EAAE,8BAA8B;IAC/C,iBAAiB,EAAE,wCAAwC;IAC3D,mBAAmB,EAAE,sBAAsB;IAC3C,kBAAkB,EAAE,4BAA4B;IAChD,UAAU,EAAE,iDAAiD;IAC7D,QAAQ,EAAE,0BAA0B;IACpC,gBAAgB,EAAE,2BAA2B;AACjD;;;EAGE,+DAA+D;EAC/D;;IAEE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;;;EAGb","sourcesContent":["/* CompanyList.css */\n\n/* Estilo para o modal */\n.custom-modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 20px;\n    border-radius: 5px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n    max-width: 400px;\n    width: 100%;\n    text-align: center;\n  }\n  \n  /* Estilo para o overlay do modal */\n  .custom-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 999;\n  }\n  \n  /* Estilo para a tabela de empresas */\n  .table {\n    margin-top: 20px;\n  }\n  \n  /* Estilo para o botão Adicionar Empresas */\n  .btn-primary {\n    margin-top: 20px;\n  }\n\n/* Estilo para o botão Adicionar Empresas */\n.btn.add-company {\n    font-size: 14px; /* Tamanho da fonte reduzido */\n    padding: 8px 16px; /* Preenchimento (espaçamento interno) */\n    border-radius: 40px; /* Borda arredondada */\n    position: absolute; /* Posicionamento absoluto */\n    top: -10px; /* Ajuste a altura superior conforme necessário */\n    left: 10; /* Alinhe com a esquerda */\n    margin-top: 10px; /* Espaço entre os botões */\n}\n\n  \n  /* Estilo para os botões de ação (Editar e Excluir) na tabela */\n  .btn-warning,\n  .btn-danger {\n    margin-right: 5px;\n  }\n\n  .space{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .text-modal{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    \n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
